import {PopupDialogbox} from 'client/CommonComponents'

interface IProps {
    Popupcontent?:any,
    hideDialog?:any,
    popupOutlinebtnOnclick?:any,
    popupPrimarybtnOnclick?:any,
    onDismiss?:any,
    popupAdditionalBtnOnCLick?: any,
    className?:any
}
const CancelConfirmationPopup = ({popupPrimarybtnOnclick,Popupcontent,hideDialog,popupOutlinebtnOnclick,popupAdditionalBtnOnCLick, onDismiss, className}:IProps) => {
    return (
        <PopupDialogbox  className={className} hideDialog={!Popupcontent.isDialogVisible} onDismiss={onDismiss} Popupcontent={Popupcontent} popupOutlinebtnOnclick={popupOutlinebtnOnclick} popupPrimarybtnOnclick={()=>popupPrimarybtnOnclick('Home')} popupAdditionalBtnOnCLick = {popupAdditionalBtnOnCLick} data-attribute="CancelConfirmationPopup_Default_PopupDilalogBox" />
    )
}

export default CancelConfirmationPopup;